import { IconAlertTriangle, IconInbox } from '@tabler/icons-react'
import { errorMessage } from '@/api/client'
import { tr } from '@/i18n/tr'
import { Button, Dots } from '@/ui'

/**
 * Yükleniyor / hata / boş durumları.
 *
 * <p>Üçü de aynı yüzeyde yaşar: kullanıcı bir listenin yerini, içi dolmadan önce
 * de görebilsin. Boş bir alan "bozuk" görünür, kesik çerçeveli bir alan "henüz boş".
 */

export function LoadingState({ label = tr.common.loading }: { label?: string }) {
  return (
    <div role="status" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, padding: '56px 0', color: 'var(--nx-fg-muted)', fontSize: 14 }}>
      <Dots />
      <span>{label}</span>
    </div>
  )
}

/**
 * Hata durumu.
 *
 * <p>{@code action}, hatanın tekrar denemekle geçmediği durumlar içindir: yetkisiz ya
 * da silinmiş bir kayıtta "Tekrar dene" her seferinde aynı duvara çarpar; kullanıcıya
 * çıkacak bir kapı gösterilmezse adres çubuğunu elle düzeltmekten başka yolu kalmaz.
 */
export function ErrorState({
  error, onRetry, action,
}: {
  error: unknown
  onRetry?: () => void
  action?: React.ReactNode
}) {
  return (
    <div role="alert" style={{
      display: 'flex', gap: 12, alignItems: 'flex-start', margin: '16px 0', padding: '16px 18px', borderRadius: 'var(--nx-r-card)',
      background: 'var(--nx-danger-soft-bg)', border: '1px solid var(--nx-danger-soft-border)', color: 'var(--nx-danger-fg)',
    }}>
      <IconAlertTriangle size={20} style={{ flexShrink: 0, marginTop: 1 }} aria-hidden="true" />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'flex-start', minWidth: 0 }}>
        <div>
          <div style={{ fontWeight: 600, fontSize: 14 }}>{tr.common.error}</div>
          <div style={{ fontSize: 14, color: 'var(--nx-fg-2)', marginTop: 2 }}>{errorMessage(error)}</div>
        </div>
        {(onRetry || action) && (
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {onRetry && <Button size="sm" variant="danger-soft" onClick={onRetry}>{tr.common.retry}</Button>}
            {action}
          </div>
        )}
      </div>
    </div>
  )
}

export function EmptyState({
  title, hint, icon, action,
}: {
  title: string
  hint?: string
  icon?: React.ReactNode
  action?: React.ReactNode
}) {
  return (
    <div className="ui-empty">
      <span className="ui-empty__icon" aria-hidden="true">{icon ?? <IconInbox size={22} stroke={1.6} />}</span>
      <span className="ui-empty__title">{title}</span>
      {hint && <span className="ui-empty__hint">{hint}</span>}
      {action}
    </div>
  )
}
